var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMusic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0625 24C14.8542 24 15.5208 23.7292 16.0625 23.1875C16.6042 22.6458 16.875 21.9792 16.875 21.1875V16.5H20.625V14H15.625V18.8438C15.3958 18.6771 15.1512 18.5571 14.8913 18.4837C14.6304 18.4113 14.3542 18.375 14.0625 18.375C13.2708 18.375 12.6042 18.6458 12.0625 19.1875C11.5208 19.7292 11.25 20.3958 11.25 21.1875C11.25 21.9792 11.5208 22.6458 12.0625 23.1875C12.6042 23.7292 13.2708 24 14.0625 24ZM8.125 27.75C7.4375 27.75 6.84917 27.5054 6.36 27.0163C5.87 26.5263 5.625 25.9375 5.625 25.25V5.25C5.625 4.5625 5.87 3.97375 6.36 3.48375C6.84917 2.99458 7.4375 2.75 8.125 2.75H18.125L25.625 10.25V25.25C25.625 25.9375 25.3804 26.5263 24.8913 27.0163C24.4013 27.5054 23.8125 27.75 23.125 27.75H8.125ZM16.875 11.5V5.25H8.125V25.25H23.125V11.5H16.875Z",
    fill: "#F6EFE9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusic);
export default __webpack_public_path__ + "static/media/music.da6616a3aa31848c9deceb76fde8a8a7.svg";
export { ForwardRef as ReactComponent };